import { useState } from 'react';
import './TaskInput.css';

const IMPORTANCE_LEVELS = [
  { value: 'low', label: '🟢 Low' },
  { value: 'medium', label: '🟡 Medium' },
  { value: 'high', label: '🔴 High' }
];

const TaskInput = ({ onAddTask }) => {
  const [taskText, setTaskText] = useState('');
  const [importance, setImportance] = useState('medium');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (taskText.trim()) {
      onAddTask({
        text: taskText.trim(),
        importance
      });
      setTaskText('');
      setImportance('medium');
    }
  };

  return (
    <form className="task-input-form" onSubmit={handleSubmit}>
      <input
        type="text"
        value={taskText}
        onChange={(e) => setTaskText(e.target.value)}
        placeholder="Add a new task..."
        className="task-input"
      />
      <select
        value={importance}
        onChange={(e) => setImportance(e.target.value)}
        className="task-importance-select"
      >
        {IMPORTANCE_LEVELS.map(level => (
          <option key={level.value} value={level.value}>
            {level.label}
          </option>
        ))}
      </select>
      <button type="submit" className="task-submit-btn">
        Add Task
      </button>
    </form>
  );
};

export default TaskInput;